import { getDocuments } from '../services/documents';
import { TenantsProps } from '../types/responses/Tenants';

const getTenants = async (userPk = null): Promise<TenantsProps> => {
  const data: any = await getDocuments(`tenants${userPk != null ? '?userPk=' + userPk : ''}`);
  return data;
};

export { getTenants };
